<footer class="lp-footer row">
  <span class="col"> © {{currentYear - 1}}-{{currentYear}} by cloudficient Software AG, Switzerland</span>
  <div class="col text-lg-end">
    <a href="https://www.cloudficient.com/technology/remad-platform" target="_blank">
      <img alt="remad logo" src="../assets/images/logo/remad-logo.png"/>
    </a>
  </div>
</footer>
